function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167.9 70.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.79,43.01c-2.72-.26-6.06-.7-6.06-3.86,0-2.81,2.99-4.39,6.5-4.39s6.5,1.23,6.58,4.3h11.59c.44-8.95-8.25-13.52-18.35-13.52S.88,30.02.88,39.5c0,10.27,11.06,11.41,19.58,12.55,2.98.44,6.06.79,6.06,4.22-.09,3.78-3.69,4.83-7.29,4.83-3.51.09-6.85-1.49-6.93-5H0c.44,11.24,10.18,14.05,19.75,14.05s18.79-3.77,19.05-13.87c.26-11.33-10.54-12.11-20.02-13.26",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.37,21.41l-.09,5.35h-7.99v8.69h7.81v33.54h11.94v-33.54h13.34v-8.69h-13.34v-5.09c0-9.04,7.99-8.69,14.31-6.32l1.23-9.13c-13.87-4.21-27.21-2.11-27.21,15.19",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.76,59.08c-7.02,2.55-14.31,2.11-14.31-6.67v-16.42h13.78v-9.22h-13.78v-13.17h-9.83l-1.32,13.17h-8.87v8.43l7.99.79v16.68c0,17.38,12.91,19.75,27.48,15.71l-1.14-9.31Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.1,15.23V3.89h2.88c3.36,0,5.18,2.67,5.18,5.63s-1.77,5.71-5.18,5.71h-2.88Zm12.01-5.74C20.1,4.79,16.93.32,11.03.32h-6.88v18.48h6.88c5.98,0,9.15-4.58,9.07-9.31",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.32,3.73h3.97c1.69,0,2.72,1.24,2.72,2.8.03,1.59-1.06,2.88-2.72,2.88h-3.97V3.73Zm.05,8.94h3.31l3.81,6.11h4.23v-.55l-4.18-6.16c2.12-1.03,3.31-3.1,3.31-5.45,0-3.28-2.3-6.35-6.53-6.35-2.64-.03-5.26,0-7.91,0v18.51h3.97v-6.11Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.45,9.55c0-3.91,2.59-5.9,5.5-5.9s5.47,1.96,5.47,5.9-2.62,5.95-5.5,5.95-5.48-1.9-5.48-5.95m14.92,0c0-6.21-4.58-9.55-9.42-9.55s-9.49,3.31-9.49,9.55,4.47,9.57,9.42,9.57c5.61,0,9.49-3.94,9.49-9.57",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.56 8.22 77.03 18.85 78.22 18.85 78.22 .29 74.26 .29 74.26 10.79 63.86 .21 62.62 .21 62.62 18.8 66.56 18.8 66.56 8.22",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.5 10.98 93.38 10.98 93.38 7.51 86.5 7.51 86.5 3.76 93.85 3.76 93.85 .29 82.51 .29 82.51 18.8 94.06 18.8 94.06 15.21 86.5 15.21 86.5 10.98",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.02,70.12h0c12.31,0,22.29-9.98,22.3-22.29h-22.3v22.29Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.02,25.54h0c-12.31,0-22.29,9.98-22.3,22.29h22.3v-22.29Z",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.559937ad0e337ff9d3289dad99661315.svg";
export { ForwardRef as ReactComponent };